import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@app/shared/shared.module';
import { ColorSchemeService, ColorScheme } from '@app/shared/services/color-scheme.service';

@Component({
  selector: 'app-webview-session',
  standalone: true,
  templateUrl: './webview-session.component.html',
  imports: [CommonModule, SharedModule],
})
export class WebviewSessionComponent implements OnInit {
  constructor(private readonly colorSchemeService: ColorSchemeService) {
  }

  ngOnInit() {
    if (typeof window === 'undefined') {
      return;
    }

    try {
      localStorage.setItem('isCoinmateWebview', 'true');
    } catch (error) {
      console.warn('Failed to set isCoinmateWebview in localStorage:', error);
    }

    // Get theme parameter from URL and set it using ColorSchemeService
    const urlParams = new URLSearchParams(window.location.search);
    const theme = urlParams.get('theme');
    if (theme && (theme === 'dark' || theme === 'light')) {
      const colorScheme = theme === 'dark' ? ColorScheme.DARK : ColorScheme.LIGHT;
      this.colorSchemeService.setColorScheme(colorScheme);
    }
  }
}
